export default function TrustBar() {
  const items = [
    {
      icon: 'ri-shield-check-line',
      title: 'Hijyenik Üretim',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Düzenli Hizmet',
    },
    {
      icon: 'ri-time-line',
      title: 'Zamanında Servis',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'İhtiyaca Özel Çözüm',
    },
  ];

  return (
    <section className="bg-accent-950 py-8 md:py-10 border-y border-accent-900/50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          {items.map((item) => (
            <div
              key={item.title}
              className="reveal flex flex-col items-center text-center gap-3"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/10 border border-primary-500/20">
                <i className={`${item.icon} text-2xl md:text-3xl text-primary-400`}></i>
              </div>
              <span className="font-label text-sm md:text-base font-semibold text-background-100">
                {item.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}